import { render, staticRenderFns } from "./invoices.vue?vue&type=template&id=5529655a"
import script from "./invoices.vue?vue&type=script&lang=js"
export * from "./invoices.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports